import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Instrument } from "../../types";
import { getInstruments, getInstrumentById } from "@/api";

interface UseInstrumentsController {
  instruments: Instrument[];
  filteredInstruments: Instrument[];
  isLoading: boolean;
  error: unknown;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  refresh: () => void;
}

export const useInstrumentsController = (): UseInstrumentsController => {
  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: instruments = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["instruments"],
    queryFn: async () => {
      const instruments = await getInstruments();
      return instruments;
    },
  });

  const refresh = () => {
    refetch();
  };

  const filteredInstruments = useMemo(() => {
    if (!instruments) return [];

    if ((searchQuery ?? "").trim() !== "") {
      return instruments.filter((instrument) =>
        instrument.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    return instruments;
  }, [searchQuery, instruments]);

  return {
    instruments,
    filteredInstruments,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
    refresh,
  };
};
